import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import classNames from 'classnames';
import { IlIconInitializer, IlButton, IlIcon } from 'il-framework-component';
import PropTypes from 'prop-types';
import React__default, { useState, useRef, useEffect } from 'react';
import util from 'util';
import { UserInteractionStatus, Priority } from './InAppConstants.js';
import { InAppNotification } from './InAppNotification.js';
import { getAllNotifications, updateNotification } from './APIRequets.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NOTIFICATION_INITIAL_LIMIT = 4;
var SHOW_MORE_INCREMENT_COUNTER = 2;
var PRIORITY_LOW_CLASSNAME = 'priority-low';
var PRIORITY_HIGH_CLASSNAME = 'priority-high';
var PRIORITY_MEDIUM_CLASSNAME = 'priority-medium';
var NOTIFICATION_URL = '/v3/apis/inapp-delivery/inApp/notifications';
var NOTIFICATION_URL_WITH_LIMIT = '/v3/apis/inapp-delivery/inApp/notifications?limit=%d';
function InAppNotificationContainer(_ref) {
  var workspaceId = _ref.workspaceId,
    roleType = _ref.roleType,
    applicationId = _ref.applicationId,
    hostUrl = _ref.hostUrl;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    apiInitialLimit = _useState2[0],
    setApiInitialLimit = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSeeMoreBtn = _useState4[0],
    setShowSeeMoreBtn = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    notificationClicked = _useState6[0],
    setNotificationClicked = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    unreadNotificationsCount = _useState8[0],
    setUnreadNotificationsCount = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    notificationListItems = _useState10[0],
    setNotificationListItems = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    totalNotificationListItems = _useState12[0],
    setTotalNotificationListItems = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showNotificationList = _useState14[0],
    setShowNotificationList = _useState14[1];
  var _useState15 = useState(NOTIFICATION_URL.concat('?applicationId=').concat(applicationId)),
    _useState16 = _slicedToArray(_useState15, 2);
    _useState16[0];
    var setNotificationURL = _useState16[1];
  var _useState17 = useState(NOTIFICATION_INITIAL_LIMIT),
    _useState18 = _slicedToArray(_useState17, 2),
    notificationsListLimit = _useState18[0],
    setNotificationsListLimit = _useState18[1];
  var _useState19 = useState(PRIORITY_LOW_CLASSNAME),
    _useState20 = _slicedToArray(_useState19, 2),
    notificationCountClassname = _useState20[0],
    setNotificationCountClassname = _useState20[1];
  // const fetchNotificationResult = useFetch(notificationURL);
  var _useState21 = useState({}),
    _useState22 = _slicedToArray(_useState21, 2),
    fetchNotificationResult = _useState22[0],
    setFetchNotificationResult = _useState22[1];
  var wrapperRef = useRef(null);
  var handleTotalUnreadNotificationCount = function handleTotalUnreadNotificationCount(notificationList) {
    if (notificationList) {
      var unreadNotifications = notificationList.filter(function (notification) {
        return notification.state === UserInteractionStatus.DELIVERED;
      });
      setUnreadNotificationsCount(unreadNotifications.length);
    }
  };
  var handleShowMoreBtnState = function handleShowMoreBtnState(dataLength, limit) {
    if (dataLength > 10 && dataLength < limit) {
      setShowSeeMoreBtn(false);
    } else if (dataLength <= limit) {
      setShowSeeMoreBtn(false);
    } else {
      setShowSeeMoreBtn(true);
    }
  };

  /**
   * @param fetchedNotificationData
   * @returns Filtered notficationList based on Workspace.
   */
  var filterNotificationList = function filterNotificationList(fetchedNotificationData) {
    if (Object.keys(fetchedNotificationData).length > 0) {
      var filteredNotificationList = fetchedNotificationData.data.filter(function (notification) {
        return Object.prototype.hasOwnProperty.call(notification.context, 'workspaceId') === false || notification.context.workspaceId === workspaceId && roleType === 'MANAGER_PLUS';
      });
      return _objectSpread(_objectSpread({}, fetchedNotificationData), {}, {
        data: filteredNotificationList
      });
    }
    return {};
  };
  var fetchNotificationListItem = function fetchNotificationListItem(fetchedNotificationResult) {
    var _filteredData$data;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOTIFICATION_INITIAL_LIMIT;
    var filteredData = filterNotificationList(fetchedNotificationResult);
    var notificationListItem = filteredData && filteredData.data && filteredData.data.reduce(function (ids, i) {
      if (ids.length === limit) return ids;
      ids.push(i);
      return ids;
    }, []);
    var dataLength = filteredData === null || filteredData === void 0 || (_filteredData$data = filteredData.data) === null || _filteredData$data === void 0 ? void 0 : _filteredData$data.length;
    setApiInitialLimit(dataLength);
    handleShowMoreBtnState(dataLength, limit);
    setNotificationListItems(notificationListItem);
    setTotalNotificationListItems(filteredData === null || filteredData === void 0 ? void 0 : filteredData.data);
    handleTotalUnreadNotificationCount(filteredData === null || filteredData === void 0 ? void 0 : filteredData.data);
  };
  var handleShowMoreNotification = function handleShowMoreNotification() {
    var newLimit = notificationsListLimit + SHOW_MORE_INCREMENT_COUNTER;
    setNotificationsListLimit(newLimit);
    if (notificationsListLimit < apiInitialLimit) {
      fetchNotificationListItem(fetchNotificationResult, newLimit);
    } else {
      var newURL = util.format(NOTIFICATION_URL_WITH_LIMIT, newLimit);
      setNotificationURL(newURL);
      fetchNotificationListItem(fetchNotificationResult, newLimit);
    }
  };
  var handleClickOutside = function handleClickOutside(event) {
    var seeMoreBtnClass = 'seeMore';
    var showMoreBtnClass = 'il-link-button';
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && !(event.target.className === showMoreBtnClass) && !(event.target.id === seeMoreBtnClass)) {
      setShowNotificationList(false);
    }
  };
  var showUnreadMessage = function showUnreadMessage() {
    return setShowNotificationList(!showNotificationList);
  };
  useEffect(function () {
    var updateNotificationStatus = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var reqData, requestOptions, updatedNotificationList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              reqData = {
                inAppNotificationId: notificationClicked === null || notificationClicked === void 0 ? void 0 : notificationClicked.id,
                applicationId: notificationClicked === null || notificationClicked === void 0 ? void 0 : notificationClicked.application
              };
              Object.keys(reqData).forEach(function (key) {
                if (reqData[key] === '') {
                  delete reqData[key];
                }
              });
              requestOptions = {
                data: reqData
              }; // eslint-disable-next-line no-useless-catch
              _context.prev = 3;
              _context.next = 6;
              return updateNotification(requestOptions, hostUrl);
            case 6:
              updatedNotificationList = totalNotificationListItems.map(function (notification) {
                if (notification.id === notificationClicked.id) {
                  return _objectSpread(_objectSpread({}, notification), {}, {
                    state: UserInteractionStatus.READ
                  });
                }
                return notification;
              });
              setNotificationListItems(updatedNotificationList.slice(0, notificationsListLimit));
              setTotalNotificationListItems(updatedNotificationList);
              handleTotalUnreadNotificationCount(updatedNotificationList);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              throw _context.t0;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 12]]);
      }));
      return function updateNotificationStatus() {
        return _ref2.apply(this, arguments);
      };
    }();
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(notificationClicked && notificationClicked.state === UserInteractionStatus.DELIVERED)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return updateNotificationStatus();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }, [notificationClicked]);
  useEffect(function () {
    if (notificationListItems && notificationListItems.length) {
      var countUrgent = totalNotificationListItems.filter(function (notification) {
        return notification.state === UserInteractionStatus.DELIVERED && (notification.priority === Priority.CRITICAL || notification.priority === Priority.HIGH);
      }).length;
      var countImportant = totalNotificationListItems.filter(function (notification) {
        return notification.state === UserInteractionStatus.DELIVERED && notification.priority === Priority.MEDIUM;
      }).length;
      if (countUrgent > 0) {
        setNotificationCountClassname(PRIORITY_HIGH_CLASSNAME);
      } else if (countImportant > 0) {
        setNotificationCountClassname(PRIORITY_MEDIUM_CLASSNAME);
      } else {
        setNotificationCountClassname(PRIORITY_LOW_CLASSNAME);
      }
    }
  }, [totalNotificationListItems]);
  useEffect(function () {
    fetchNotificationListItem(fetchNotificationResult);
  }, [fetchNotificationResult]);
  useEffect(function () {
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var notifications;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getAllNotifications(hostUrl, applicationId);
          case 3:
            notifications = _context3.sent;
            setFetchNotificationResult(notifications);
            _context3.next = 10;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw _context3.t0;
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 7]]);
    }))();
  }, []);
  useEffect(function () {
    document.addEventListener('click', handleClickOutside, false);
    return function () {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, notificationListItems && notificationListItems.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: classNames('il-inapp-notification__notification'),
    ref: wrapperRef,
    "data-testid": "il-inapp-notification__notification"
  }, /*#__PURE__*/React__default.createElement(IlIconInitializer, null), /*#__PURE__*/React__default.createElement("div", {
    className: "il-inapp-notification__notification--show-bell-icon"
  }, /*#__PURE__*/React__default.createElement(IlButton, {
    className: "il-inapp-notification__notification-bell-btn",
    kind: "ghost",
    size: "small",
    onClick: showUnreadMessage
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '15px',
      height: '15px',
      fill: '#fff'
    }
  }, /*#__PURE__*/React__default.createElement(IlIcon, {
    name: "notifications",
    className: "il-inapp-notification__notification-bell-icon"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "il-inapp-notification__notification--show-count",
    style: {
      visibility: "".concat(unreadNotificationsCount > 0 ? 'visible' : 'hidden')
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: notificationCountClassname
  }, /*#__PURE__*/React__default.createElement("span", {
    "data-testid": "il-inapp-notification__notification-count"
  }, unreadNotificationsCount)))), showNotificationList && /*#__PURE__*/React__default.createElement(InAppNotification, {
    notificationList: notificationListItems,
    handleShowMoreNotification: handleShowMoreNotification,
    setNotificationClicked: setNotificationClicked,
    showSeeMoreBtn: showSeeMoreBtn
  })));
}
InAppNotificationContainer.propTypes = {
  workspaceId: PropTypes.string,
  roleType: PropTypes.string,
  applicationId: PropTypes.string,
  hostUrl: PropTypes.string
};

export { InAppNotificationContainer };
